// extracted by mini-css-extract-plugin
module.exports = {"h2":"PageTitle_h2__4MzOd"};